import { Api } from '../axiosApi';

// Empresa desativada no painel de controle — checado logo após o login (ver
// AuthContext.tsx), antes de deixar o usuário entrar no sistema.
const verificarAtiva = async (): Promise<boolean> => {
  try {
    const { data } = await Api.get('/empresa/status');
    return data?.ativa !== false;
  } catch {
    // Falha na consulta não pode travar o acesso de ninguém.
    return true;
  }
};

export const EmpresaStatusService = {
  verificarAtiva,
};
